module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.28b58355.png";